import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezonePlugin from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezonePlugin)

export const useTimezone = () => {
  function getBrowserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  function getDateRangeForTimezone(dateStr: string, tz: string = 'UTC'): {
    startDate: string
    endDate: string
  } {
    return {
      startDate: dayjs.tz(dateStr, tz).startOf('day').utc().toISOString(),
      endDate: dayjs.tz(dateStr, tz).endOf('day').utc().toISOString(),
    }
  }

  function formatDateForAPI(date: Date): string {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  function formatDateTimeForAPI(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${formatDateForAPI(date)}T${hours}:${minutes}:${seconds}`
  }

  return {
    getBrowserTimezone,
    getDateRangeForTimezone,
    formatDateForAPI,
    formatDateTimeForAPI,
  }
}
